import { render, staticRenderFns } from "./BooleanButton.template.vue?vue&type=template&id=37486841&scoped=true&"
var script = {}
import style0 from "./BooleanButton.template.vue?vue&type=style&index=0&id=37486841&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37486841",
  null
  
)

export default component.exports